import baseAxiosInstance from "./axios"

export const ApiRequest = async function (options) {
  const onSuccess = function (response) {
    return Promise.resolve(response)
  }

  const onError = function (error) {
    return Promise.reject(error)
  }

  try {
    let response = await baseAxiosInstance(options)
    return onSuccess(response)
  } catch (error) {
    console.log("error", error)
    return onError(error)
  }
}
